import { styled } from '@mui/material/styles';

import { TMoplaColors, TMoplaColorsV2 } from '@mopla/mui';

export interface IRootProps {
	color?: TMoplaColors | TMoplaColorsV2;
	type?: 'base' | 'warning';
}

export const Root = styled('div')<{ ownerState: IRootProps }>(
	({ theme, ownerState: { type, color } }) =>
		theme.unstable_sx({
			display: 'grid',
			gridTemplateColumns: 'max-content 1fr',
			gridAutoRows: 'max-content',
			gap: '8px',
			alignItems: 'start',
			color,

			'& .iconWrapper svg': {
				display: 'block',
			},

			...(type === 'warning' && {
				borderRadius: '8px',
				padding: '8px',
				backgroundColor: theme.palette.warning.light,
				color: theme.palette.neutral[100],
				alignItems: 'center',

				'& .iconWrapper': {
					color: theme.palette.warning.main,
				},
			}),

			'& .label': {
				alignSelf: 'center',
			},

			'& .footer': {
				gridColumn: '2 / -1',
			},
		})
);
